import { giphyAnalytics } from 'shared/api'
import log from 'shared/util/log'
import checkIsEmbed from 'shared/util/is-embed'
import normalizePageViewUrl from 'shared/util/normalize-page-view-urls'

const didomiCode = "c:googleana-jHcphUGX"

declare global {
    interface Window { 
        didomiOnReady: unknown[]; 
        gaCreated: boolean;
        ga: Function
    }
}

export function trackPageView(trackingUrl: string, normalize: boolean = true) {
    if (!trackingUrl || !window.dataLayer) return

    if (normalize) {
        trackingUrl = normalizePageViewUrl(trackingUrl)
    }

    if (trackingUrl) {
        log.debug(`trackPageView virtualPageURL: ${trackingUrl}`)

        window.didomiOnReady.push(function (Didomi) {
            if (Didomi.getUserConsentStatusForVendor(didomiCode)) {
                // analytics
                window.dataLayer.push({
                    event: 'VirtualPageview',
                    virtualPageURL: trackingUrl,
                    virtualPageName: trackingUrl,
                })
            }
        })
    }
}

export const initGoogleAnalytics = (isEmbed: boolean = false) => {
    if (window.gaCreated) return
    window.didomiOnReady = window.didomiOnReady || []
    window.didomiOnReady.push(function (Didomi) {
        if (Didomi.getUserConsentStatusForVendor(didomiCode)) {
            window.ga(
                'create',
                'UA-38174542-1',
                isEmbed ? { cookieDomain: 'auto', cookieFlags: 'SameSite=None; Secure' } : 'auto'
            )
            window.gaCreated = true

            const { dataLayer = [] } = window
            const [firstDataLayer = {}] = dataLayer
            if (firstDataLayer.loggedInStatus === 'true') {
                window.ga('set', 'userId', firstDataLayer.userID)
                window.ga('set', 'verifiedStatus', firstDataLayer.verifiedStatus)
                window.ga('set', 'userType', firstDataLayer.userType)
            }
        }
    })
}

type DataLayerProps = {
    dimension: string | number | symbol
    value: unknown
}

export const setGTADataLayer = ({ dimension, value }: DataLayerProps) => {
    // all subsequent page views will have our custom dimension
    const event = {
        [dimension]: value,
    }
    log.info('dataLayer.push', event)
    window.dataLayer.push(event)
}

export const googleAnalyticsEvent = ({ category, action, label, value = null }) => {
    const isEmbed = checkIsEmbed()
    initGoogleAnalytics(isEmbed)
    log.debug(
        `googleAnalyticsEvent category: ${category} action: ${action} label: ${label} ${value ? `value: ${value}` : ''}`
    )

    // Ignore didomi if is embed
    if (isEmbed) {
        window.ga && window.ga('send', 'event', category, action, label, value)
    } else {
        window.didomiOnReady.push(function (Didomi) {
            if (Didomi.getUserConsentStatusForVendor(didomiCode)) {
                window.ga && window.ga('send', 'event', category, action, label, value)
            }
        })
    }
}

export const giphyAnalyticsEvent = async ({ shareType, gifId }) => {
    try {
        await giphyAnalytics(shareType, gifId)
    } catch (e) {
        log.error(`Error sending giphyAnalyticsEvent ${e}`)
    }
}

export const encodeGAParams = (p) =>
    Object.entries(p)
        .map((kv) => kv.map(encodeURIComponent).join('='))
        .join('&')

export default {
    trackPageView,
    initGoogleAnalytics,
    googleAnalyticsEvent,
}
